<template>
  <div>
    <!-- Pass the dynamic videoSrc to the VideoPlayer component -->
    <VideoPlayer :videoSrc="videoUrl" />
  </div>
</template>

<script>
import VideoPlayer from "./components/VideoPlayer.vue";

export default {
  components: {
    VideoPlayer,
  },
  data() {
    return {
      videoUrl: "",
    };
  },
  created() {
    this.videoUrl = this.getVideoUrl();
  },
  methods: {
    getVideoUrl() {
      const params = new URLSearchParams(window.location.search);
      const videoParam = params.get("video");
      if (videoParam) {

        console.log(videoParam);
        // Assuming videoParam contains the full URL or a valid video path
        //return `https://file-examples.com/storage/fec85039006734629a992d7/2017/04/${videoParam}.mp4`;

        //return `https://s3.antoinebrossault.com/main-dev/quick-vidz/${videoParam}.mp4`
        return `https://mys3.fooor.xyz/main-dev/vidz/${videoParam}.mp4`;
      }
      // Default video if no parameter is provided
      return "https://file-examples.com/storage/fec85039006734629a992d7/2017/04/file_example_MP4_480_1_5MG.mp4";
    },
  },
};
</script>